import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  defaultFonts,
  clipart,
  clipartCategories,
  clipartLimits
} from "../../actions";

import Canvas from "../../components/Canvas";

class CanvasContainer extends React.Component {
  componentDidMount() {
    if (Object.values(this.props.fonts.fonts).length === 0) {
      this.props.requestDefaultFonts({});
    }
    if (Object.values(this.props.clipart.clipart).length === 0) {
      this.props.requestClipart({});
      this.props.requestClipartCategories({});
      this.props.requestClipartLimits({});
    }
  }

  render() {
    return (
      <Canvas
        productColor={this.props.productColor}
        toggleTools={this.props.toggleTools}
        toolsVisible={this.props.toolsVisible}
        handleZoom={this.props.handleZoom}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    fonts: state.fonts,
    clipart: state.clipart,
    upload: state.upload
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      requestDefaultFonts: defaultFonts.request,
      requestClipart: clipart.request,
      requestClipartCategories: clipartCategories.request,
      requestClipartLimits: clipartLimits.request
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(CanvasContainer);
